export default __webpack_public_path__ + "static/media/sheren-heskel.31187dbb.png";